import { Navigate, Route, Routes } from "react-router-dom";
import Dashboard from "../cms/features/feature_dashboard/Dashboard";
import LogindPage from "cms/features/feature_user/pages/LoginPage";
import JobScreen from "cms/features/feature_job/pages/JobScreen";
import CmsJobDetailsPage from "cms/features/feature_job/pages/JobDetailsPage";
import CompanyScreen from "cms/features/feature_job/pages/CompanyScreen";
import CmsCompanyDetailsPage from "cms/features/feature_job/pages/CompanyDetailsPage";
import CVScreen from "cms/features/feature_cv/pages/CVScreen";
import CmsCVDetailsPage from "cms/features/feature_cv/pages/CVDetailsPage";
import UsersScreen from "cms/features/feature_user/pages/UsersScreen";
import UserDetailsPage from "cms/features/feature_user/pages/UserDetailsPage";
import BenefitScreen from "cms/features/feature_job/pages/BenefitScreen";
import ScheduleScreen from "cms/features/feature_job/pages/ScheduleScreen";
import JobTypeScreen from "cms/features/feature_job/pages/JobTypeScreen";
import CategoryScreen from "cms/features/feature_job/pages/CategoryScreen";
import TranslationsPage from "cms/features/feature_setting/pages/TranslationsPage";
import SettingsPage from "cms/features/feature_setting/pages/SettingsPage";
import CountriesManagementPage from "cms/features/feature_setting/pages/CountriesManagementPage";
import HomePage from "features/feature_home/pages/HomePage";
import JobDetailsPage from "features/feature_job/pages/JobDetailsPage";
import JobApplicationPage from "features/feature_job/pages/JobApplicationPage";
import PrivateRoute from "./PrivateRoute";
import EmployerRoute from "./EmployerRoute";
import PublicShell from "core/layout/PublicShell";
import InfoPage from "features/feature_info/pages/InfoPage";
import ProfilePage from "features/feature_user/pages/ProfilePage";
import { HttpService } from "core/services/http";
import JobsPage from "features/feature_job/pages/JobsPage";
import CompaniesPage from "features/feature_job/pages/CompaniesPage";
import CompanyDetailsPage from "features/feature_job/pages/CompanyDetailsPage";
import CandidatesPage from "features/feature_job/pages/CandidatesPage";
import CandidateDetailsPage from "features/feature_job/pages/CandidateDetailsPage";
import CVPage from "features/feature_cv/pages/CVPage";
import CVBuilderPage from "features/feature_cv/pages/CVBuilderPage";
import CVDetailsPage from "features/feature_cv/pages/CVDetailsPage";
import AICVBuilderPage from "features/feature_cv/pages/AICVBuilderPage";
import AICVEditorPage from "features/feature_cv/pages/AICVEditorPage";
import ShareableCVPage from "features/feature_cv/pages/ShareableCVPage";
import PrintableCVPage from "features/feature_cv/pages/PrintableCVPage";
import RenderCVBuilderPage from "features/feature_rendercv/pages/RenderCVBuilderPage";
import RenderCVPreviewPage from "features/feature_rendercv/pages/RenderCVPreviewPage";

import ApplicationsScreen from "cms/features/feature_job/pages/ApplicationsScreen";
import ApplicationDetailsPage from "cms/features/feature_job/pages/ApplicationDetailsPage";
import SignupPage from "features/feature_user/pages/SignupPage";
import LoginPage from "features/feature_user/pages/LoginPage";
import EmployerDashboard from "features/feature_user/pages/EmployerDashboard";
import MyCompanyPage from "features/feature_user/pages/MyCompanyPage";
import EmployerJobsPage from "features/feature_user/pages/EmployerJobsPage";
import EmployerJobDetailsPage from "features/feature_user/pages/EmployerJobDetailsPage";
import EmployerApplicationDetailsPage from "features/feature_user/pages/EmployerApplicationDetailsPage";
import EmployerApplicationsPage from "features/feature_user/pages/EmployerApplicationsPage";
import EmployerCandidatesPage from "features/feature_user/pages/EmployerCandidatesPage";
import EmployerCandidateDetailsPage from "features/feature_user/pages/EmployerCandidateDetailsPage";
import EmployeesPage from "features/feature_user/pages/EmployeesPage";
import NewJobPage from "features/feature_user/pages/NewJobPage";
import SalarySpecificationsPage from "features/feature_user/pages/SalarySpecificationsPage";
import SalarySpecificationDetailsPage from "features/feature_user/pages/SalarySpecificationDetailsPage";
import DeductionsContributionsPage from "features/feature_user/pages/DeductionsContributionsPage";
import SalaryDetailsPage from "features/feature_user/pages/SalaryDetailsPage";
import InvoicesPage from "features/feature_user/pages/InvoicesPage";
import InvoiceDetailsPage from "features/feature_user/pages/InvoiceDetailsPage";
import ReportsPage from "features/feature_user/pages/ReportsPage";
import ContractsPage from "features/feature_user/pages/ContractsPage";
import ContractDetailsPage from "features/feature_user/pages/ContractDetailsPage";
import ContractPrintPage from "features/feature_user/pages/ContractPrintPage";
import EmployerDashboardLayout from "features/feature_user/layout/EmployerDashboardLayout";
import JobseekerDashboardLayout from "features/feature_user/layout/JobseekerDashboardLayout";
import JobseekerDashboard from "features/feature_user/pages/JobseekerDashboard";
import JobseekerApplicationsPage from "features/feature_user/pages/JobseekerApplicationsPage";
import JobseekerApplicationDetailsPage from "features/feature_user/pages/JobseekerApplicationDetailsPage";
import JobseekerProfilePage from "features/feature_user/pages/JobseekerProfilePage";
import JobseekerCVsPage from "features/feature_user/pages/JobseekerCVsPage";
import NotificationsPage from "features/feature_user/pages/NotificationsPage";
import CMSWrapper from "cms/core/shared/CMSWrapper";
import { ThemeProvider as CmsThemeProvider } from "cms/core/context/ThemeContext";
import useProfile from "features/feature_user/hooks/UseProfile";
import { Utils } from "core/utils";

const MainRoutes = () => {
  const localStorageToken = HttpService.getToken()
  const localStorageInfo = HttpService.getUser()
  
  // Load profile to get role
  const { data: profile } = useProfile({ enabled: !!localStorageToken });
  
  // Get role from profile or localStorage user object
  const userRole = Utils.getUserRole() || profile?.role || localStorageInfo?.role;

  const _adminRoutes = () => {
    if (userRole !== "admin") {
      return null;
    }
    return (
      <Route path="/cms" element={<CMSWrapper />}>
        <Route index element={<Navigate to="/cms/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="job" element={<JobScreen />} />
        <Route path="job/:id" element={<CmsJobDetailsPage />} />
        <Route path="company" element={<CompanyScreen />} />
        <Route path="company/:id" element={<CmsCompanyDetailsPage />} />
        <Route path="schedules" element={<ScheduleScreen />} />
        <Route path="benefits" element={<BenefitScreen />} />
        <Route path="jobtypes" element={<JobTypeScreen />} />
        <Route path="categories" element={<CategoryScreen />} />
        <Route path="user" element={<UsersScreen />} />
        <Route path="user/:id" element={<UserDetailsPage />} />
        <Route path="cv" element={<CVScreen />} />
        <Route path="cv/:id" element={<CmsCVDetailsPage />} />
        <Route path="applications" element={<ApplicationsScreen />} />
        <Route path="applications/:id" element={<ApplicationDetailsPage />} />
        <Route path="settings" element={<SettingsPage />} />
        <Route path="translations" element={<TranslationsPage />} />
        <Route path="countries" element={<CountriesManagementPage />} />
      </Route>
    );
  };

  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<PublicShell />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/job/:id" element={<JobDetailsPage />} />
        <Route path="/job/:id/:slug" element={<JobDetailsPage />} />
        <Route path="/job/:id/apply" element={<JobApplicationPage />} />
        <Route path="/jobs" element={<JobsPage />} />
        <Route path="/employers" element={<CompaniesPage />} />
        <Route path="/employer/:id" element={<CompanyDetailsPage />} />
        <Route path="/candidates" element={<CandidatesPage />} />
        <Route path="/candidate/:id" element={<CandidateDetailsPage />} />
        <Route path="/cv" element={<CVPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/signup" element={<SignupPage />} />
        {["about", "contact", "help", "privacy", "terms"].map((page) => (
          <Route key={page} path={`/${page}`} element={<InfoPage page={page} />} />
        ))}
      </Route>
      <Route path="/cv/builder" element={<CVBuilderPage />} />
      <Route path="/cv/builder/:id" element={<CVBuilderPage />} />
      <Route path="/cv/ai-builder" element={<AICVBuilderPage />} />
      <Route path="/cv/ai-editor/:id" element={<AICVEditorPage />} />
      <Route path="/cv/:id" element={<CVDetailsPage />} />
      <Route path="/cv/share/:shareUUID" element={<ShareableCVPage />} />
      <Route path="/cv/print/:shareUUID" element={<PrintableCVPage />} />
      <Route path="/cv/print/id/:id" element={<PrintableCVPage />} />
      <Route path="/cv/rendercv-builder" element={<RenderCVBuilderPage />} />
      <Route path="/cv/rendercv/:id" element={<RenderCVPreviewPage />} />
      
      <Route path="/cms/login" element={<LogindPage />} />
      
      
      {/* Admin Routes */}
      {userRole !== "admin" && (
        <Route path="/cms" element={<LogindPage />} />
      )}
      {/* No session, or a signed-in non-admin: any other /cms URL goes to the CMS login */}
      {(!localStorageToken || (userRole && userRole !== "admin")) && (
        <Route path="/cms/*" element={<Navigate to="/cms/login" replace />} />
      )}

      {/* Private Routes */}
      {/* <Route path="/home" element={<PrivateRoute><UserDashboard /></PrivateRoute>} /> */}
      <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
      
      {/* Employer Routes with Layout - Protected by EmployerRoute */}
      <Route
        path="/employer"
        element={
          <EmployerRoute>
            <CmsThemeProvider>
              <EmployerDashboardLayout />
            </CmsThemeProvider>
          </EmployerRoute>
        }
      >
        <Route path="dashboard" element={<EmployerDashboard />} />
        <Route path="my-company" element={<MyCompanyPage />} />
        <Route path="jobs" element={<EmployerJobsPage />} />
        <Route path="jobs/new" element={<NewJobPage />} />
        <Route path="jobs/:id" element={<EmployerJobDetailsPage />} />
        <Route path="applications" element={<EmployerApplicationsPage />} />
        <Route path="applications/:id" element={<EmployerApplicationDetailsPage />} />
        <Route path="candidates" element={<EmployerCandidatesPage />} />
        <Route path="candidates/:id" element={<EmployerCandidateDetailsPage />} />
        <Route path="employees" element={<EmployeesPage />} />
        <Route path="salary-specification" element={<SalarySpecificationsPage />} />
        <Route path="salary-specification/:id" element={<SalarySpecificationDetailsPage />} />
        <Route path="salary-specification/:id/deductions" element={<DeductionsContributionsPage />} />
        <Route path="salary-specification/:id/salary-details" element={<SalaryDetailsPage />} />
        <Route path="invoices" element={<InvoicesPage />} />
        <Route path="invoices/:id" element={<InvoiceDetailsPage />} />
        <Route path="contracts" element={<ContractsPage />} />
        <Route path="contracts/:id" element={<ContractDetailsPage />} />
        <Route path="contracts/:id/print" element={<ContractPrintPage />} />
        <Route path="reports" element={<ReportsPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
      </Route>

      {/* Jobseeker Routes with Layout */}
      <Route path="/jobseeker" element={<PrivateRoute><JobseekerDashboardLayout /></PrivateRoute>}>
        <Route path="dashboard" element={<JobseekerDashboard />} />
        <Route path="profile" element={<JobseekerProfilePage />} />
        <Route path="applications" element={<JobseekerApplicationsPage />} />
        <Route path="applications/:id" element={<JobseekerApplicationDetailsPage />} />
        <Route path="cvs" element={<JobseekerCVsPage />} />
        <Route path="notifications" element={<NotificationsPage />} />
      </Route>

      {/* Legacy notifications route - redirects based on user role */}
      <Route path="/notifications" element={<PrivateRoute><NotificationsPage /></PrivateRoute>} />


      {localStorageToken && userRole === "admin" && _adminRoutes()}
      {/* <Route path="/login" element={<CmsLogin />} /> */}
    </Routes>
  );
};

export default MainRoutes;